import { render, staticRenderFns } from "./o-notifications-api.vue?vue&type=template&id=ba9f8e4e&scoped=true&"
import script from "./o-notifications-api.vue?vue&type=script&lang=js&"
export * from "./o-notifications-api.vue?vue&type=script&lang=js&"
import style0 from "./o-notifications-api.vue?vue&type=style&index=0&id=ba9f8e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9f8e4e",
  null
  
)

export default component.exports